<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.27</b> - Улучшения производительности, новый префикс оружия, панорамирование вида Пещеры, и многое другое!
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Добавлено обучение для новых игроков</li>
      <li>Вид Пещеры теперь можно панорамировать щелчком+перетаскиванием</li>
      <li>Добавлен новый префикс оружия "Гладиаторский" - 20% шанс оглушить.</li>
      <li>
        Добавлены команды модератора для заглушения плохо ведущих себя игроков; назначены модераторами Mr. Gentle, Trevor,
        Draquonis2019, и Meisterlampe.
      </li>
      <li>Аудио теперь будет заглушено при переключении вкладок / сворачивании игры.</li>
      <li>Призыв магазина Пыльца пикси к вишлистам теперь является призывом к отзывам</li>
      <li>
        Улучшения производительности
        <ul>
          <li>- Обломки мёртвых тел теперь исчезают через 60 секунд</li>
          <li>- Исправлена (серьёзная) утечка памяти на экране редактирования героя</li>
          <li>- Проведена оптимизация анимации peanuts</li>
          <li>- Исправлена утечка памяти Пещеры</li>
          <li>- Проведена оптимизация отрисовки благословение</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
